import type { ReactNode } from 'react';

/** Inset between the card edge and the collection's content. */
export const CARD_PADDING_PX = 12;

interface Props {
  /** Card fill — `rackColors().cardBackground`, resolved by the caller. */
  backgroundColor: string;
  /** Card hairline — `rackColors().cardBorder`. */
  borderColor: string;
  children: ReactNode;
}

/**
 * The card behind a collection custom button — the SAME translucent surface the
 * My Store tab's collection card uses (`rackColors`: 10% black on light / 10%
 * white on dark, with the white hairline), so a collection reads identically
 * whether the creator left it in My Store or moved it into the link-in-bio.
 *
 * Takes resolved colors so the caller owns the one `rackColors` read. The
 * collection button deliberately does NOT use `customButtonStyle` (the
 * creator's per-button bg / border / radius) — this module follows the
 * collection card, not the button styling.
 *
 * Pure and server-renderable; shared by the visitor registry entry and the
 * owner editor's `Collection` branch so the card can't drift between them.
 */
export function CollectionButtonCard({
  backgroundColor,
  borderColor,
  children,
}: Props) {
  return (
    <div
      className="w-full overflow-hidden rounded-2xl border shadow-lg"
      style={{ backgroundColor, borderColor, padding: CARD_PADDING_PX }}
    >
      {children}
    </div>
  );
}
